import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputMask from 'react-input-mask';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

function CuitMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      required
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/]}
    />
  );
}

function DniMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      required
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]}
    />
  );
}


function PassportMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      required
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[A-Za-z0-9]/,/[A-Za-z0-9]/,/[A-Za-z0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]}
    />
  );
}


function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      required
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
}



const TaxData = ({
  type,
  onChange,
  value,
  error,
  disabled,
  children,
  title,
  document_types,
  iva_types,
  iva_conditions,
  tax_data,
  countries,
  iibb_types,
  validateCuit,
  cuitExists,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'tax_data')
  }

  const getMask = document_type_id => {
    var mask = TextMaskCustom
    document_types.map((val, idx)=>{
      if (parseInt(val.id) === parseInt(document_type_id)){
        if (val.name === 'DNI'){
          mask = DniMaskCustom
        } else if (val.name === 'CUIT' || val.name === 'CUIL'){
          mask = CuitMaskCustom
        } else if (val.name === 'PASAPORTE') {
          mask = PassportMaskCustom
        } else {
          mask = TextMaskCustom
        }
      }
    })

    return mask
  }

  const classes = useStyles();
  const mask = getMask(tax_data.document_type_id);
  const iva_conditions_buy = iva_conditions.filter(cond => cond.is_buy === 1 || cond.is_buy === '1')
  let iva_conditions_sell = iva_conditions.filter(cond => cond.is_sell === 1 || cond.is_sell === '1')
  iva_conditions_sell = (tax_data.iva_type_id !== 5 && tax_data.iva_type_id !== '5') ? iva_conditions_sell : []
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>País</Typography>
        <Select native name='country_id'
            inputProps={{
              name:"country_id",
              className:"country_id"
            }}
            className="mr-2"
            error={(error !=='' && tax_data.country_id ==='') ? 'Debe completar este campo' :  false }
            disabled={disabled}
            required  
            style={{minWidth: 150, fontSize: '0.75rem'}}
            onChange={handleChange}
            value={tax_data.country_id}
            input={<Input id="grouped-native-select" name='country_id'/>}>
            <option value="" label="Seleccione" />
              {countries.map((country) => <option id={country.id} value={country.id}>{country.name}
          </option>)}
        </Select>
      {(error !=='' && tax_data.country_id ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      </FormControl>

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Tipo de documento</Typography>
        <Select native name='document_type_id'
            inputProps={{
              name:"document_type_id",
              className:"document_type_id"
            }}
            error={(error !=='' && tax_data.document_type_id ==='') ? 'Debe completar este campo' :  false }
            style={{minWidth: 150, fontSize: '0.75rem'}}
            className="mr-2"
            onChange={handleChange}
            required  
            disabled={disabled}
            value={tax_data.document_type_id}
            input={<Input id="grouped-native-select" name='document_type'/>}>
            <option value="" label="Seleccione" />
              {document_types.map((document_type) => <option id={document_type.id} value={document_type.id}>{document_type.name}
          </option>)}
        </Select>
      {(error !=='' && tax_data.document_type_id ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      </FormControl>

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>CUIT/CUIL</Typography>
        <Input
          id="document_number"
          name="document_number"
          label="CUIT / CUIL"
          required  
          disabled={disabled}
          placeholder="Ingrese el CUIT o CUIL"
          margin="normal"
          className="mr-2 mt-0 mb-0"
          InputLabelProps={{
            shrink: true
          }}
          error={(error !=='' && tax_data.document_number.replace(/[^0-9]/g,"").length !== 11) ? 'Debe completar este campo' :  false }
          helperText= {(error !=='' && tax_data.document_number.replace(/[^0-9]/g,"").length !== 11 ) ? 'Debe completar este valor' : ''}
          inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
          value={tax_data.document_number}
          onChange={handleChange}
          onBlur={validateCuit}
          inputComponent={mask}
        />
      {(error !=='' && tax_data.document_number.replace(/[^0-9]/g,"").length !== 11) && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      {(error !=='' && cuitExists)  && <FormHelperText style={{color: 'red'}}>El CUIT / CUIL ya existe</FormHelperText>}        
      </FormControl>

      <TextField
        id="cuit_date_verification"
        name="cuit_date_verification"
        type="date"
        placeholder="Ingrese la fecha de vigencia de verificación"
        label="Fecha de vigencia CUIT"
        disabled={disabled}
        required  
        onChange={handleChange}
        value={tax_data.cuit_date_verification}
        margin="normal"
        className="mr-2 mt-3"
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Condición IVA de compras</Typography>
        <Select native name='iva_type_buy_id'
            inputProps={{
              name:"iva_type_buy_id",
              className:"iva_type_buy_id"
            }}
            className="mr-2"
            label="Seleccione"
            InputLabelProps={{
              shrink: true
            }}
            style={{minWidth: 150, fontSize: '0.75rem'}}
            onChange={handleChange}
            //required  
            disabled={disabled}
            value={tax_data.iva_type_buy_id}
            input={<Input id="grouped-native-select" name='iva_type_buy_id'/>}>
            <option value="" label="Seleccione"/>
            {iva_conditions_buy.map((iva_condition) => <option id={iva_condition.id} value={iva_condition.id}>{iva_condition.name}
          </option>)}
        </Select>
      </FormControl>

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Condición IVA de ventas</Typography>
        <Select native name='iva_type_sell_id'
            inputProps={{
              name:"iva_type_sell_id",
              className:"iva_type_sell_id"
            }}
            className="mr-2"
            style={{minWidth: 150, fontSize: '0.75rem'}}
            required  
            onChange={handleChange}
            disabled={disabled}
            value={tax_data.iva_type_sell_id}
            input={<Input id="grouped-native-select" name='iva_type_sell_id'/>}>
            <option value="" label="Seleccione"/>
            {iva_conditions_sell.map((iva_condition) => <option id={iva_condition.id} value={iva_condition.id}>{iva_condition.name}
          </option>)}
        </Select>
      </FormControl>
      
      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Condición frente a IVA</Typography>
        <Select native name='iva_type_id'
            inputProps={{
              name:"iva_type_id",
              className:"iva_type_id"
            }}
            className="mr-2"
            style={{minWidth: 150, fontSize: '0.75rem'}}
            required  
            onChange={handleChange}
            disabled={disabled}
            value={tax_data.iva_type_id}
            input={<Input id="grouped-native-select" name='iva_type_id'/>}>
            <option value="" label="Seleccione" />
            {iva_types.map((iva_type) => <option id={iva_type.id} value={iva_type.id}>{iva_type.name}
          </option>)}
        </Select>
        {(error !=='' && (tax_data.iva_type_id ==='' || tax_data.iva_type_id === undefined)) && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      </FormControl>

      <FormControl required className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Tipo de IIBB</Typography>
      <Select native name='client_iibb_type_id'
          inputProps={{
            name:"client_iibb_type_id",
            className:"client_iibb_type_id"
          }}
          style={{minWidth: 150, fontSize: '0.75rem'}}
          disabled={disabled}
          onChange={handleChange}
          required
          error={(error !=='' && (tax_data.client_iibb_type_id ==='' || tax_data.client_iibb_type_id === undefined)) ? 'Debe completar este campo' :  false }
          value={tax_data.client_iibb_type_id}
          input={<Input id="grouped-native-select" name='client_iibb_type_id'/>}>
          <option value=""  label="Seleccione"/>
          {iibb_types.map((iibb_type) => <option id={iibb_type.id} value={iibb_type.id}>{iibb_type.name}
        </option>)}
      </Select>
      {(error !=='' && (tax_data.client_iibb_type_id ==='' || tax_data.client_iibb_type_id === undefined)) && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
    </FormControl>

     { error && <p style={{color: 'red'}}>{ error }</p>}
    </React.Fragment>
  )
}

TaxData.defaultProps = {
  type: "text",
  className: "",
  disabled: false,
  cuitExists: false,
}

TaxData.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default TaxData;